// src/auth/apiFetch.js — full replacement
import { API_BASE_URL, getSessionHeaders } from '../services/api/config.js';

// Set by AuthContext after mount so apiFetch can trigger navigation.
let _onSessionExpired = null;
let _onTenantDenied = null;
let _onSuperadminTenantBlocked = null;
let _getIsSuperadmin = () => false;
let _getAdminMode = () => false;

export function registerAuthCallbacks({
  onSessionExpired,
  onTenantDenied,
  onSuperadminTenantBlocked,
  getIsSuperadmin,
  getAdminMode,
} = {}) {
  if (onSessionExpired !== undefined) _onSessionExpired = onSessionExpired;
  if (onTenantDenied !== undefined) _onTenantDenied = onTenantDenied;
  if (onSuperadminTenantBlocked !== undefined) _onSuperadminTenantBlocked = onSuperadminTenantBlocked;
  if (getIsSuperadmin !== undefined) _getIsSuperadmin = getIsSuperadmin;
  if (getAdminMode !== undefined) _getAdminMode = getAdminMode;
}

export function getAuthCallbacks() {
  return { onSessionExpired: _onSessionExpired, onTenantDenied: _onTenantDenied };
}

export async function apiFetch(path, options = {}) {
  const { suppressTenantHeader, ...fetchOptions } = options;
  const token = localStorage.getItem('auth_token');
  const tenantId = localStorage.getItem('auth_tenant_id');

  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...fetchOptions,
    headers: {
      'Content-Type': 'application/json',
      ...getSessionHeaders(),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(!suppressTenantHeader && tenantId ? { 'X-Tenant-Id': tenantId } : {}),
      ...(fetchOptions.headers || {}),
    },
  });

  if (res.status === 401) {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_tenants');
    localStorage.removeItem('auth_tenant_id');
    _onSessionExpired?.();
    throw new Error('SESSION_EXPIRED');
  }

  if (res.status === 403) {
    const body = await res.clone().json().catch(() => ({}));
    if (body.error_code === 'TENANT_ACCESS_DENIED') {
      if (_getIsSuperadmin() && _getAdminMode() && _onSuperadminTenantBlocked) {
        // Superadmin in admin mode hit a tenant-scoped route by accident.
        // Don't clear tenant_id; keep adminMode; surface a banner.
        _onSuperadminTenantBlocked();
        throw new Error('SUPERADMIN_TENANT_BLOCKED');
      }
      localStorage.removeItem('auth_tenant_id');
      _onTenantDenied?.();
      throw new Error('TENANT_DENIED');
    }
  }

  return res;
}
